var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.iframeUrl),callback:function ($$v) {_vm.iframeUrl=$$v},expression:"iframeUrl"}})],1),_c('iframe',{attrs:{"allow":"microphone; camera","src":_vm.iframeUrl,"width":"100%","height":"500px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }